import { render, staticRenderFns } from "./BlogSlider.vue?vue&type=template&id=0bdcd121&scoped=true"
import script from "./BlogSlider.vue?vue&type=script&lang=js"
export * from "./BlogSlider.vue?vue&type=script&lang=js"
import style0 from "./BlogSlider.vue?vue&type=style&index=0&id=0bdcd121&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdcd121",
  null
  
)

export default component.exports